/*
 * Copyright (c) 2020 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The Input Error component
 *
 * @author Thais Watanabe
 */
const InputError = (props) => {
  return (
    <p className="mt-2 text-sm text-red-600" id="email-error">
      {props.children}
    </p>
  );
};

export default InputError;
